// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group-item {
  background-color: #eff8ff;
  border: 0px;
}

.icon-tick {
  position: absolute;
  /* top: -6px; */
  left: 0;
  display: inline;
  width: 25px;
  height: 25px;
  line-height: 30px;
  border-radius: 50%;
  background: #fe5e15;
  text-align: center;
  color: #fff;
  font-size: 15px;
  transition: all 200ms linear;
  transition-delay: 0.1s;
  /* margin-right: 100px; */
}

.list-group-item-custom {
  display: flex;
  align-items: center;
}

.icon-tick {
  flex-shrink: 0;
  /* margin-right: 10px; */
}

.item-title {
  flex-grow: 1;
  margin-left: 20px;
  text-align: justify;
}

.text-primary {
  flex-shrink: 0;
  margin-left: 10px;
}

.icon-document {
  margin-left: 5px;
}

/*  new*/
.list-group-item-custom {
  display: flex;
  align-items: flex-start; /* Align the items at the start */
  margin-left: 20px;
}

.icon-tick {
  flex-shrink: 0;
  margin-right: 10px;
}

.item-title {
  margin-bottom: 5px; /* Add some space between title and link */
  text-align: justify; /* Justify the text */
}

.text-primary {
  align-self: flex-start;
}

.bullet-point {
  font-size: 15px;
  color: #555;
  margin-bottom: 10px;
  list-style-type: disc;
  margin-left: 20px;
  line-height: normal;
  text-align: left;
}
/* var(--thm-base) */

@media only screen and (max-width: 768px) {
  /* apply the above styles here */
  .feature-three__tab-button {
    flex-wrap: nowrap;
    overflow-x: auto;
  }
  .feature-three__tab-button ul.tab-buttons {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .feature-three__tab-button li.tab-btn {
    flex: 1 1;
    margin: 0 10px;
  }
  .feature-three__tab-content {
    font-size: 0.8em;
    text-align: justify;
    margin: 0.5em;
    padding: 0.5em;
  }
  .feature-three__tab-content .tab {
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 768px) {
  .feature-three__tab-button {
    position: relative;
    display: block;
    padding-bottom: 3px;
    font-size: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .tab-buttons {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/documents/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,uBAAuB,EAAE,iCAAiC;EAC1D,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,0CAA0C;EAC9D,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,oBAAoB;;AAEpB;EACE,gCAAgC;EAChC;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,SAAO;IACP,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".list-group-item {\n  background-color: #eff8ff;\n  border: 0px;\n}\n\n.icon-tick {\n  position: absolute;\n  /* top: -6px; */\n  left: 0;\n  display: inline;\n  width: 25px;\n  height: 25px;\n  line-height: 30px;\n  border-radius: 50%;\n  background: #fe5e15;\n  text-align: center;\n  color: #fff;\n  font-size: 15px;\n  transition: all 200ms linear;\n  transition-delay: 0.1s;\n  /* margin-right: 100px; */\n}\n\n.list-group-item-custom {\n  display: flex;\n  align-items: center;\n}\n\n.icon-tick {\n  flex-shrink: 0;\n  /* margin-right: 10px; */\n}\n\n.item-title {\n  flex-grow: 1;\n  margin-left: 20px;\n  text-align: justify;\n}\n\n.text-primary {\n  flex-shrink: 0;\n  margin-left: 10px;\n}\n\n.icon-document {\n  margin-left: 5px;\n}\n\n/*  new*/\n.list-group-item-custom {\n  display: flex;\n  align-items: flex-start; /* Align the items at the start */\n  margin-left: 20px;\n}\n\n.icon-tick {\n  flex-shrink: 0;\n  margin-right: 10px;\n}\n\n.item-title {\n  margin-bottom: 5px; /* Add some space between title and link */\n  text-align: justify; /* Justify the text */\n}\n\n.text-primary {\n  align-self: flex-start;\n}\n\n.bullet-point {\n  font-size: 15px;\n  color: #555;\n  margin-bottom: 10px;\n  list-style-type: disc;\n  margin-left: 20px;\n  line-height: normal;\n  text-align: left;\n}\n/* var(--thm-base) */\n\n@media only screen and (max-width: 768px) {\n  /* apply the above styles here */\n  .feature-three__tab-button {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n  .feature-three__tab-button ul.tab-buttons {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n  }\n  .feature-three__tab-button li.tab-btn {\n    flex: 1;\n    margin: 0 10px;\n  }\n  .feature-three__tab-content {\n    font-size: 0.8em;\n    text-align: justify;\n    margin: 0.5em;\n    padding: 0.5em;\n  }\n  .feature-three__tab-content .tab {\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .feature-three__tab-button {\n    position: relative;\n    display: block;\n    padding-bottom: 3px;\n    font-size: 10px;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .tab-buttons {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
